"use client";

import { useQuery } from "@tanstack/react-query";

import {
  PostSignupBenefitTarget,
  PostSignupServiceBenefit,
  selectPostSignupServiceBenefit,
} from "@/lib/post-signup-service-benefit";

import { selfScheduleQueryOptions } from "@/api/check-in/self-schedule/self-schedule-query";

interface PostSignupServiceBenefitState {
  benefit: PostSignupServiceBenefit | null;
  /** True while self-scheduling is still being checked for a bookable match. */
  isResolving: boolean;
}

/** Resolve new benefits that map to bookable self-schedule services. */
export const usePostSignupServiceBenefit = (
  targets: PostSignupBenefitTarget[],
): PostSignupServiceBenefitState => {
  const hasConcreteTarget = targets.some((target) => target.itemId);
  const { data: frontPage, isLoading } = useQuery({
    ...selfScheduleQueryOptions.frontPage(),
    enabled: hasConcreteTarget,
  });

  return {
    benefit: selectPostSignupServiceBenefit(targets, frontPage?.services ?? []),
    isResolving: hasConcreteTarget && isLoading,
  };
};
